import { createClient } from 'usage-tracker-core';
import { genericClient } from 'usage-tracker-core/client';
import http from 'hub-http/clients/noAuthApiClient';
import { getPortalId } from '../../utils/getPortalId';
import { captureException } from '../../utils/sentryAPI';
import { getFullUrl } from 'hubspot-url-utils';
const origin = getFullUrl('app');
const path = '/usage-logging/v1/log/hublytics-multi/no-auth';
const getHubId = () => {
  const hubId = getPortalId();
  if (hubId) {
    return hubId;
  }
  return null;
};
export default function createNavTrackingClient(userEmail) {
  return createClient({
    clientName: 'unified-navigation-ui',
    getDebug: genericClient.getDebug,
    getHstc: genericClient.getHstc,
    getTempStorage: genericClient.getTempStorage,
    setTempStorage: genericClient.setTempStorage,
    logError: genericClient.logError,
    logWarning: genericClient.logWarning,
    reportError: genericClient.reportError,
    reportWarning: genericClient.reportWarning,
    getLang: genericClient.getLang,
    getEmail: () => userEmail,
    getHubId,
    send: ({
      events,
      query,
      isBeforeUnload
    }) => {
      const endpoint = `${path}?${query}`;
      const beaconEndpoint = `${origin}${endpoint}`;
      const data = events;
      const sendXhr = () => http.post(endpoint, {
        data,
        safeMode: true
      }).catch(err => {
        captureException(err);
      });
      const onFailure = () => {
        sendXhr().catch(captureException);
      };
      if (isBeforeUnload) {
        return genericClient.sendBeacon(beaconEndpoint, data, onFailure);
      }
      return sendXhr();
    }
  });
}